import { render, staticRenderFns } from "./BaseIcon.html?vue&type=template&id=5c2cd766&scoped=true&"
import script from "./BaseIcon.js?vue&type=script&lang=js&"
export * from "./BaseIcon.js?vue&type=script&lang=js&"
import style0 from "./BaseIcon.scss?vue&type=style&index=0&id=5c2cd766&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2cd766",
  null
  
)

export default component.exports